// View CRM Details › Stage 1 Timeline / Agreement Timeline (M1-F7, M1.21) — as prototype s1Timeline.
// Done steps in time order with who and when, then the open ones in process order.
import React from "react";
import dayjs from "dayjs";

// Who does each step (prototype s1Steps) and what an open step waits for.
const WHO = {
  TAGGED: "System", APPLICATION_EMAIL: "System", AFB_CONFIRMED: "Customer", UNIT_SANCTIONED: "System", KYC: "Customer",
  REVIEW_DRAFT_SENT: "System", FEMALE_CHECK: "System", LOYALTY: "Customer", REVIEW_DRAFT: "Customer", AV_APPROVAL: "CRM",
  PARKING: "CRM", SDR_PAYMENT: "Customer", STAGE1_COMPLETE: "System", FINAL_REVIEW: "CRM",
  ALLOTMENT_LETTER_ESIGN: "Customer", FARVISION_SYNC: "System", CF_NOC: "Banking", FINAL_DRAFT: "Customer",
  APPOINTMENT: "CRM", STAMP: "CRM", DOCUMENT_PRINT: "Document Manager",
};
const WAITING = {
  TAGGED: "Accept or reject on the card",
  APPLICATION_EMAIL: "Sent when the CRM accepts",
  AFB_CONFIRMED: "Waiting for the customer · the Agreement KYC opens after this",
  UNIT_SANCTIONED: "Waiting for sanction · checked every day at 03:00",
  KYC: "Waiting for the customer",
  REVIEW_DRAFT_SENT: "After the KYC is submitted",
  LOYALTY: "After the KYC",
  REVIEW_DRAFT: "After review draft",
  AV_APPROVAL: "Preview and Approve",
  PARKING: "After AV and plan",
  SDR_PAYMENT: "After the CRM selects parking",
  STAGE1_COMPLETE: "When every step above is done",
  FINAL_REVIEW: "After all steps",
};
const ACTOR = { CUSTOMER: "Customer", CRM: "CRM", CRM_MANAGER: "CRM Manager", CRM_HEAD: "CRM Head", ACCOUNTS: "Accounts", BANKING: "Banking", DOCUMENT_MANAGER: "Document Manager", RIDER: "Rider", SYSTEM: "System" };
const COLOR = { Customer: "#B54708", CRM: "#155EEF", "CRM Head": "#6941C6", System: "#667085" };

const okIcon = (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#ECFDF3" stroke="#12B76A" /><path d="M7 12.5l3.2 3.2L17 9" fill="none" stroke="#12B76A" strokeWidth="2" /></svg>
);
const pendIcon = (
  <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="#F9FAFB" stroke="#D0D5DD" /><circle cx="12" cy="12" r="3" fill="#D0D5DD" /></svg>
);

function Crm2StepTimeline({ tracker, stage, heading }) {
  const s = tracker?.stages?.[stage];
  if (!s) return null;
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "1rem", marginBottom: "1.6rem", flexWrap: "wrap" }}>
        <p style={{ fontSize: "1.6rem", color: "#101828", fontWeight: 600, margin: 0 }}>{heading}</p>
        <span style={{ fontSize: "1.2rem", fontFamily: "Inter-Medium", color: "#3538CD", background: "#EEF4FF", borderRadius: "1.6rem", padding: "0.2rem 1rem" }}>
          {s.done} of {s.total} done
        </span>
      </div>
      <div>
        {s.steps.map((step, k) => {
          const done = step.status === "DONE";
          const who = done ? step.doneBy?.name || ACTOR[step.actorType] || WHO[step.stepCode] : WHO[step.stepCode];
          const whoColor = COLOR[done ? ACTOR[step.actorType] || who : who] || "#155EEF";
          return (
            <div key={step.stepCode} style={{ display: "flex", gap: "1.2rem" }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {done ? okIcon : pendIcon}
                {k < s.steps.length - 1 && <i style={{ flex: 1, width: "2px", background: "#EAECF0", minHeight: "1.6rem" }} />}
              </div>
              <div style={{ paddingBottom: "1.6rem", fontSize: "1.4rem" }}>
                <b style={{ color: "#101828" }}>{step.label}</b>
                {step.reopenCount > 0 && <span style={{ color: "#B54708" }}> · reopened {step.reopenCount}×</span>}
                <div>
                  <span style={{ color: whoColor, fontWeight: 600 }}>{who}</span>
                  {" · "}
                  {done ? dayjs(step.doneAt).format("DD MMM YYYY, hh:mm A") : <i style={{ color: "#667085" }}>{WAITING[step.stepCode] || "Waiting"}</i>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Crm2StepTimeline;
